import { isPublicRoute } from "./routeUtils";

const PRODUKTLY_SCRIPT_ID = "produktlyScript";
const PRODUKTLY_SRC = "https://public.produktly.com/js/main.js";

/**
 * Produktly is for the authenticated / marketing app only — same surfaces as Frontegg.
 * Public booking routes use `isPublicRoute()` (see routeUtils + PUBLIC_ROUTES).
 */
export function loadProduktlyIfApplicable(): void {
  if (typeof document === "undefined") return;
  if (isPublicRoute()) return;
  if (document.getElementById(PRODUKTLY_SCRIPT_ID)) return;

  const token =
    "b7ebd8d87b70d7646738de144b966b6815ab94cb26f62e6295c24d5885db292c9657d0509cf80f296acc171fe4aa2f7497e6fbcea2dbd3a3a5ddb0415abcbd97daba3c25a230275e9a1845c41eea8feebda7bda56ddb2f6c1c8b088fb067d2f8e582f81e";

  const script = document.createElement("script");
  script.async = true;
  script.id = PRODUKTLY_SCRIPT_ID;
  script.src = PRODUKTLY_SRC;
  script.dataset.clientToken = token;
  document.head.appendChild(script);
}
